export const locKeys = {
  imagePlaceHolder: "hotels.imagePlaceHolder",
  moduleTitle: "tripAttach.module.title",
  savingsAction: "tripAttach.savings.action",
  savingsCar: "tripAttach.savings.car.description",
  savingsCarAction: "tripAttach.savings.car.action",
  savingsCarTitle: "tripAttach.savings.car.title",
  savingsHotel: "tripAttach.savings.hotel.description",
  savingsHotelAction: "tripAttach.savings.action",
  savingsHotelTitle: "tripAttach.savings.hotel.title",
  savingsTitle: "tripAttach.savings.title",
  tripTitle: "tripAttach.trip.title",
};
